// src/utils/uiApiUrl.ts
//
// Joins a path onto the UI API base (`VITE_API_URL`, which already ends in
// `/api/v1/ui`). Callers pass the path below that base (`users/me`); a leading
// `ui/` is dropped so the segment is never doubled (`/api/v1/ui/ui/users/me`).
import { API_CONFIG } from '@/config/constants';

export const uiApiUrl = (path: string, baseUrl: string = API_CONFIG.BASE_URL ?? ''): string => {
  const base = baseUrl.replace(/\/+$/, '');
  let rest = path.replace(/^\/+/, '');
  if (/\/ui$/.test(base)) rest = rest.replace(/^ui\//, '');
  return `${base}/${rest}`;
};
